

export const CUSTOMER_CARE_PHONE_RAW = '8554143319';

export const CUSTOMER_CARE_PHONE_DISPLAY = '(855) 414-3319';

export const CUSTOMER_CARE_PHONE_TEL = 'tel:+18554143319';

export const CUSTOMER_CARE_EMAIL_RETAIL = 'Customercare@loandepot.com';

export const CUSTOMER_CARE_EMAIL_NONRETAIL = 'CustomerCare@loandepot.com';

export const CUSTOMER_CARE_HOURS_RETAIL = 'MON-FRI 7AM-6PM PST';

export const CUSTOMER_CARE_HOURS_NONRETAIL = 'MON-FRI 8 AM - 5 PM PST';

export const CUSTOMER_CARE_DESCRIPTION = 'Have any issues with your loan process? We are here to help you.';

export const CUSTOMER_CARE_NONRETAIL_PHONE_RAW = '8883376888';

export const CUSTOMER_CARE_NONRETAIL_PHONE_DISPLAY = '(888) 337-6888';

export const CUSTOMER_CARE_NONRETAIL_PHONE_EXT = '6789';

export const CUSTOMER_CARE_NONRETAIL_PHONE_TEL = 'tel:+18883376888;ext=6789';

export const SUPPORT_TROUBLESHOOTING_PHONE_RAW = '8889833717';

export const SUPPORT_TROUBLESHOOTING_PHONE_DISPLAY = '(888) 983-3717';

export const SUPPORT_TROUBLESHOOTING_PHONE_TEL = 'tel:+18889833717';

export const SUPPORT_TROUBLESHOOTING_EMAIL = 'CustomerSupport@loandepot.com';

export const SUPPORT_TROUBLESHOOTING_HOURS = 'MON-FRI 5 AM - 4 PM PST';

export const SUPPORT_TROUBLESHOOTING_DESCRIPTION = 'Assistance with e-Sign, uploading documents or using this site.';

export const MORTGAGE_PAYMENTS_PHONE_RAW = '8662586572';

export const MORTGAGE_PAYMENTS_PHONE_DISPLAY = '(866) 258-6572';

export const MORTGAGE_PAYMENTS_PHONE_TEL = 'tel:+18662586572';

export const MORTGAGE_PAYMENTS_EMAIL = 'servicing@loandepot.com';

export const MORTGAGE_PAYMENTS_HOURS = '8 AM - 5 PM PST';

export const MORTGAGE_PAYMENTS_DESCRIPTION = 'Assistance with sending in your mortgage payment.';

export const MORTGAGE_PAYMENTS_URL = 'https://www.loandepot.com/about/loan-servicing';

export const MORTGAGE_PAYMENTS_LINK_LABEL = 'Pay My Mortgage Loan';

export const PERSONAL_LOAN_PAYMENTS_PHONE_RAW = '8552416424';

export const PERSONAL_LOAN_PAYMENTS_PHONE_DISPLAY = '(855) 241-6424';

export const PERSONAL_LOAN_PAYMENTS_PHONE_TEL = 'tel:+18552416424';

export const PERSONAL_LOAN_PAYMENTS_HOURS = '5 AM - 8 PM PST';

export const PERSONAL_LOAN_PAYMENTS_DESCRIPTION = 'Assistance with sending in your personal loan payments.';

export const PERSONAL_LOAN_PAYMENTS_URL = 'https://loandepot.1stassociates.com/';

export const PERSONAL_LOAN_PAYMENTS_LINK_LABEL = 'Pay My Personal Loan';

export const MORTGAGE_PROCESS_BROCHURE_URL = 'https://www.loandepot.com/mortgageprocessbrochure';

export const MORTGAGE_PROCESS_BROCHURE_LABEL = 'View Mortgage Process Brochure';

export const LOANDEPOT_TOLL_FREE_RAW = '8883376888';

export const LOANDEPOT_TOLL_FREE_DISPLAY = '(888) 337-6888';

export const LOANDEPOT_TOLL_FREE_TEL = 'tel:+18883376888';
